import React, { useState } from "react";
import { LegStyles } from "../legs/LegStyles";
import { BoardStyles } from "../board/BoardStyles";

export const Full = ({
  legsMaterials,
  legsModels,
  boardMaterials,
  boardParametters,
  activeProduct,
  setActiveProduct,
  isActive,
  basePrice,
  setPrice,
  dims,
  setOverrideStep,
  overrideStep,
  setActiveStep,
  setLegPrice,
}) => {
  const handleNextStep = () => {
    setOverrideStep((prev) => prev + 1);
  };
  if (overrideStep == 4) {
    setActiveStep();
  }
  const resetLegs = {
    completedBoard: false,
    completedLegMaterials: false,
    completedModels: false,
    boardMaterial: null,
    boardWeight: null,
    legMaterial: null,
    legColor: null,
    legModel: null,
  };
  const [state, setState] = useState({
    completedMaterials: false,
    completedParametters: false,
    activeItem: null,
    finisher: null,
    type: null,
    noColors: null,
    weight: null,
    shape: null,
    edge_shape: null,
    cesljano: null,
    isIncreased: false,
    isIncreasedShape: false,
    ...resetLegs,
  });
  return (
    isActive && (
      <>
        <div class="configurator-styles-full">
          <BoardStyles
            activeStep={overrideStep}
            handleNextStep={handleNextStep}
            boardMaterials={boardMaterials}
            boardParametters={boardParametters}
            setActiveProduct={setActiveProduct}
            activeProduct={activeProduct}
            basePrice={basePrice}
            setPrice={setPrice}
            dims={dims}
            setOverrideStep={setOverrideStep}
            state={state}
            setState={setState}
            resetLegs={resetLegs}
          />
          <LegStyles
            activeStep={overrideStep}
            setOverrideStep={setOverrideStep}
            handleNextStep={handleNextStep}
            legsModels={legsModels}
            legsMaterials={legsMaterials}
            activeProduct={activeProduct}
            setActiveProduct={setActiveProduct}
            setLegPrice={setLegPrice}
            basePrice={basePrice}
            state={state}
            setState={setState}
          />
        </div>
      </>
    )
  );
};
